import { useState, useEffect } from "react";
import { getExchangeRate } from "../Services/ExchangeRateService";

export const useExchangeRate = () => {
  const [exchangeRate, setExchangeRate] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchExchangeRate = async () => {
      setLoading(true);
      try {
        const response = await getExchangeRate();
        setExchangeRate(response.tasaConversion);
        setError(null);
      } catch (err) {
        setError(err as Error);
        setExchangeRate(null);
      } finally {
        setLoading(false);
      }
    };

    fetchExchangeRate();
  }, []);

  return { exchangeRate, loading, error };
};
